
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24 24\" id=\"email\" ><defs/><title>email</title><g id=\"email_Layer_2\" data-name=\"Layer 2\"><g id=\"email_Icons\"><path class=\"cls-1\" d=\"M12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-23a11 11 0 1 0 11 11A11 11 0 0 0 12 1z\" id=\"email_facebook\"/><g id=\"email_email\"><path class=\"cls-1\" d=\"M6 15.73l3.37-3.65L6 8.32v7.41zM17.26 7.35H6.74L12 13.2l5.26-5.85zM18 8.32l-3.37 3.76L18 15.73V8.32z\"/><path class=\"cls-1\" d=\"M13.81 13l-1.38 1.5a.62.62 0 0 1-.89 0L10.16 13l-3.4 3.68h10.47z\"/></g></g></g></symbol>";
module.exports = sprite.add(image, "email");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/email.svg
// module id = 649
// module chunks = 1474